var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSec3Icon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 13.875H3C2.385 13.875 1.875 13.365 1.875 12.75C1.875 12.135 2.385 11.625 3 11.625H20.25C20.865 11.625 21.375 12.135 21.375 12.75C21.375 13.365 20.865 13.875 20.25 13.875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25.875H9C8.385 25.875 7.875 25.365 7.875 24.75C7.875 24.135 8.385 23.625 9 23.625H12C12.615 23.625 13.125 24.135 13.125 24.75C13.125 25.365 12.615 25.875 12 25.875Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 25.875H15.75C15.135 25.875 14.625 25.365 14.625 24.75C14.625 24.135 15.135 23.625 15.75 23.625H21.75C22.365 23.625 22.875 24.135 22.875 24.75C22.875 25.365 22.365 25.875 21.75 25.875Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.34 31.875H9.66C3.69 31.875 1.875 30.075 1.875 24.165V11.835C1.875 5.925 3.69 4.125 9.66 4.125H20.25C20.865 4.125 21.375 4.635 21.375 5.25C21.375 5.865 20.865 6.375 20.25 6.375H9.66C4.95 6.375 4.125 7.185 4.125 11.835V24.15C4.125 28.8 4.95 29.61 9.66 29.61H26.325C31.035 29.61 31.86 28.8 31.86 24.15V16.53C31.86 15.915 32.37 15.405 32.985 15.405C33.6 15.405 34.11 15.915 34.11 16.53V24.15C34.125 30.075 32.31 31.875 26.34 31.875Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9993 12.3756C26.7143 12.3756 26.4293 12.2706 26.2043 12.0456L23.9543 9.79564C23.5193 9.36064 23.5193 8.64064 23.9543 8.20564C24.3893 7.77064 25.1093 7.77064 25.5443 8.20564L26.9993 9.66064L32.2043 4.45564C32.6393 4.02064 33.3593 4.02064 33.7943 4.45564C34.2293 4.89064 34.2293 5.61064 33.7943 6.04564L27.7943 12.0456C27.5693 12.2706 27.2843 12.3756 26.9993 12.3756Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec3Icon1);
export default __webpack_public_path__ + "static/media/sec3icon1.80386348f41d2dc5e6f9a051733c950f.svg";
export { ForwardRef as ReactComponent };